import React from "react";
import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";
import { getRouteApi } from "@tanstack/react-router";

import { Box, Card, Group, Text, SimpleGrid } from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";

import {
  TanstackMantineLink,
  TanstackActionIcon,
} from "@components/tanstack-maintine-link";

const route = getRouteApi("/_authenticated/app/accounts/$accountId/players");

export const PlayersListPage: React.FC = () => {
  const players = route.useLoaderData();
  const { t } = useTranslation();

  return (
    <SimpleGrid cols={3}>
      {players.results.map((player, idx) => {
        return (
          <Card shadow="sm" padding="lg" radius="md" withBorder key={idx}>
            <Group justify="space-between">
              <Text size="lg" fw={500}>
                {player.username}
              </Text>
              <TanstackActionIcon
                variant="transparent"
                to="/app/players/$playerId"
                params={{
                  playerId: player.id.toString(),
                }}
              >
                <IconEdit />
              </TanstackActionIcon>
            </Group>

            <Text c="dimmed">
              {t("playersListPage.playerId", { playerId: player.id })}
            </Text>

            <Text>
              {t("playersListPage.createdAt", {
                createdAtStr: DateTime.fromISO(player.date_created).toFormat(
                  "yyyy LLL dd",
                ),
              })}
            </Text>

            <Box mt="md">
              <TanstackMantineLink
                to="/app/players/$playerId/insights"
                params={{
                  playerId: player.id.toString(),
                }}
              >
                {t("playersListPage.viewInsightsButton")}
              </TanstackMantineLink>
            </Box>
          </Card>
        );
      })}
    </SimpleGrid>
  );
};
